import React, { useState } from "react";
import CodiceHTML from "./CodiceHTML";
import stilePulsanti from "../../interfaccia/stilePulsanti";


function CreaHTMLCampagne() {

    const {
        inputClasses
    } = stilePulsanti

    const lingue = ["IT", "EN", "FR"]

    const [input, setInput] = useState({
        numCamp: "",
        linkIT: "",
        linkEN: "",
        linkFR: "",
        alt: ""
    });


    const handleChange = async function (evt) {
        const value = evt.target.value;
        try {

            setInput({
                ...input,
                [evt.target.name]: value
            });

        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }



    return (
        <div className="colonnaTuttaPagina flex items-start justify-center ">
        <div className="flex items-end">
            <div  className="sfondoColonna bordoAngoloBassoSX bordoAngoloAltoSX pa4 w-30 w-20-l shadow-4">
                <label for="numCamp">Numero campagna</label><br />
                <input
                    value={input.numCamp}
                    name="numCamp" onChange={handleChange}
                    id="numCamp" className={inputClasses}
                    type="number"
                    aria-describedby="name-desc"
                    autoComplete="off" />
                <br />
                <br />
                <label for="linkIT">link IT</label><br />
                <input
                    value={input.linkIT}
                    name="linkIT" onChange={handleChange}
                    id="linkIT" className={inputClasses}
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
                <br />
                <br />
                <label for="linkEN">link EN</label><br />
                <input
                    value={input.linkEN}
                    name="linkEN" onChange={handleChange}
                    id="linkEN" className={inputClasses}
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
                <br />
                <br />
                <label for="linkFR">link FR</label><br />
                <input
                    value={input.linkFR}
                    name="linkFR" onChange={handleChange}
                    id="linkFR" className={inputClasses}
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
                <br />
                <br />
                <label for="alt">alt</label><br />
                <input
                    value={input.alt}
                    name="alt" onChange={handleChange}
                    id="alt" className={inputClasses}
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div>
            <div className="lineaSepSinistra bordoAngoloBassoDX sfondoColonna pt4 pl5 pr5 pb5 w-70 w-70-l shadow-4">
                <h3>Slide desktop</h3>
                {lingue.map((lang) => <CodiceHTML
                    numCamp={input.numCamp}
                    linkIT={input.linkIT}
                    linkEN={input.linkEN}
                    linkFR={input.linkFR}
                    deskMob="DESK"
                    lang={lang}
                    alt={input.alt}
                />)}
                <h3>Slide mobile</h3>
                {lingue.map((lang) => <CodiceHTML
                    numCamp={input.numCamp}
                    linkIT={input.linkIT}
                    linkEN={input.linkEN}
                    linkFR={input.linkFR}
                    deskMob="MOB"
                    lang={lang}
                    alt={input.alt}
                />)}
            </div>
            </div>
        </div>
    )
}

export default CreaHTMLCampagne;
